export const TEMPLATE_TYPES = {
  STANDARD: 'STANDARD',
  WRAP: 'WRAP',
};

export function inferTemplateType(template) {
  return (
    template?.templateType ??
    template?.tradePlanJson?.templateType ??
    template?.tradePlanJson?.json?.templateType ??
    TEMPLATE_TYPES.STANDARD
  );
}

export function addTemplateTypeToPayload(tradePlanJson, templateType) {
  return {
    ...tradePlanJson,
    templateType,
  };
}

function buildTypeSuffix(templateType) {
  return templateType === TEMPLATE_TYPES.WRAP ? 'Wrap' : 'Standard';
}

export function createCrossTypeSaveAsName(
  requestedName,
  templateType,
  existingTemplates
) {
  const baseName = `${requestedName} (${buildTypeSuffix(templateType)})`;
  const names = new Set(Object.keys(existingTemplates ?? {}));

  if (!names.has(baseName)) {
    return baseName;
  }

  let index = 2;
  let nextName = `${baseName} ${index}`;
  while (names.has(nextName)) {
    index += 1;
    nextName = `${baseName} ${index}`;
  }
  return nextName;
}

export function resolveTemplateSaveBehavior({
  requestedName,
  templateType,
  existingTemplates,
}) {
  const existingTemplate = existingTemplates?.[requestedName];
  if (!existingTemplate) {
    return {
      shouldPromptOverwrite: false,
      saveName: requestedName,
      usedSaveAsNew: false,
    };
  }

  if (inferTemplateType(existingTemplate) === templateType) {
    return {
      shouldPromptOverwrite: true,
      saveName: requestedName,
      usedSaveAsNew: false,
    };
  }

  return {
    shouldPromptOverwrite: false,
    saveName: createCrossTypeSaveAsName(
      requestedName,
      templateType,
      existingTemplates
    ),
    usedSaveAsNew: true,
  };
}
